import React from 'react';
import PropTypes from 'prop-types';
import WorkOrderDetails from './components/WorkOrderDetails';
import ProjectNeeds from './components/ProjectNeeds';

function WorkOrderTemplate({
  data,
  onChange,
  permitRequired,
  onPermitRequiredChange,
}) {
  const {
    details = {},
    needs = {},
  } = data;

  return (
    <div>
      <h4>Work Order Inspection Report</h4>
      <WorkOrderDetails
        details={details}
        onChange={updatedDetails => onChange(
          { ...data, details: updatedDetails },
        )}
      />
      <ProjectNeeds
        needs={needs}
        onChange={updatedNeeds => onChange({ ...data, needs: updatedNeeds })}
        permitRequired={permitRequired}
        onPermitRequiredChange={onPermitRequiredChange}
        showAdditionalMiles={false}
      />
    </div>
  );
}

WorkOrderTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  permitRequired: PropTypes.bool,
  onPermitRequiredChange: PropTypes.func,
};

export default WorkOrderTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/WorkorderTemplate.jsx